export default __webpack_public_path__ + "static/media/pass_word_bg.f0e4ae02.png";